module.exports = __webpack_public_path__ + "img/astral-txt_11.55aa724c.svg";